import React, { useEffect } from 'react';
import Button from '../../artzu-ui/src/Button';
import { Link } from 'react-router-dom';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const SendModal = ({ closeModal, loggedIn }) => {
  return (
    <div className="contact__modal__container">
      <div className="message-container">
        <FontAwesomeIcon
          icon={faCheckCircle}
          size="9x"
          className="submission-check"
        />
        <p className="submission-thank">
          <strong>Thank you!</strong>
        </p>
        <div className="contact__modal__container__message">
          We’ve received your message! Our agents will be in touch with you
          soon.
        </div>
        <Link
          to={loggedIn ? '/dashboard' : '/'}
          style={{ textDecoration: 'none' }}>
          <button onClick={() => closeModal()} className="return-home">
            Return to Home
          </button>
        </Link>
      </div>
    </div>
  );
};

export default SendModal;



// WEBPACK FOOTER //
// ./src/components/NewContact/SendModal.js